<template>
  <div>
  <Card>
      <Row>
         <!--<i-col span="24" :md="22">-->
           <!--<Form ref="searchForm" inline :model="searchForm" :label-width="120" @submit.native.prevent>
            <FormItem label="标签/Node" prop="name">
              <i-input v-model="searchForm.name" placeholder="请输入标签/Node" style="width: 200px;"></i-input>
            </FormItem>
            <FormItem :label-width="0">
              <Button type="primary" @click="getNodeList()">搜索</Button>
              <Button @click="searchReset" style="margin-left: 10px;">重置</Button>
            </FormItem>
          </Form> -->
         <!--</i-col>-->
        <i-col span="24" :md="2" style="float:right">
          <Button @click="getNodeList()" type="primary" :style="{marginBottom: '10px', float: 'right'}" icon="md-refresh">刷新</Button>
        </i-col>
       </Row>
      <tables search-place="top" v-model="tableData" :columns="columns"/>
      <Row style="margin: 10px;">
        <div style="float: right;">
          <page :total="count" :current="page" :page-size="size" @on-change="getNodeList"></page>
        </div>
     </Row>
    </Card>
  </div>
</template>
<script>
import Tables from '_c/tables'
import { getNodeList, getNodeDetail } from '@/api/cloud'
export default {
  name: 'NodeList',
  components: {
    Tables
  },
  data () {
    return {
      count: 1,
      size: 10,
      page: 1,
      change: false,
      ordering: null,
      columns: [
        { title: '节点', key: 'name', align: 'center', minWidth: 100 },
        { title: 'CPU(核)', key: 'cpu', align: 'center', minWidth: 100 },
        { title: '内存大小', key: 'memory', align: 'center', minWidth: 100 },
        {
          title: '状态',
          align: 'center',
          minWidth: 130,
          key: 'is_active',
          render: (h, params) => {
            const row = params.row
            const color = row.status === false ? 'success' : 'error'
            const text = row.status === false ? '运行中' : '已断开'
            return h('Tag', {
              props: {
                type: 'dot',
                color: color
              }
            }, text)
          }
        },
        {
          title: '操作',
          align: 'center',
          minWidth: 80,
          render: (h, params) => {
            if (this.$store.state.user.superuser) {
              return h('div', [
                h('Button', {
                  props: {
                    type: 'info',
                    size: 'small',
                    title: '详情'
                  },
                  style: {
                    marginRight: '5px'
                  },
                  on: {
                    click: () => {
                      this.viewDetail(params)
                    }
                  }
                }, '详情')
              ])
            } else {}
          }
        }
      ],
      tableData: [],
      jsonSource: {},
      changeLoadingShow: false,
      searchForm: {
        name: null
      },
      listStyle: {
        width: '250px',
        height: '300px'
      }
    }
  },
  watch: {
    '$route' (to, from) {
      // 对路由变化作出响应...
      this.getNodeList()
    }
  },
  methods: {
    getNodeList () {
      getNodeList().then(res => {
        this.tableData = res.data
        this.count = res.data.length
      })
    },
    searchReset () {
      this.searchForm.name = null
    },
    viewDetail (params) {
      this.handleRenderDetail(params)
    },
    handleRenderDetail (params) {
      getNodeDetail(params.row.name).then(res => {
        let data = res.data
        this.$Modal.info({
          width: '750px',
          title: 'Node详情',
          render: (h) => {
            return h('div', [
              h('span', {style: {color: '#515a6e'}}, '节点:'),
              h('span', {style: {color: 'green'}}, params.row.name),
              h('span', {style: {color: '#515a6e', marginLeft: '5px'}}, 'CPU(核):'),
              h('span', {style: {color: 'green'}}, params.row.cpu),
              h('span', {style: {color: '#515a6e', marginLeft: '5px'}}, '内存:'),
              h('span', {style: {color: 'green'}}, params.row.memory),
              h('Divider', {
              }),
              h('Input', {
                props: {
                  type: 'textarea',
                  value: data,
                  autofocus: true,
                  placeholder: '',
                  readonly: true,
                  autosize: { minRows: 10, maxRows: 20 }
                },
                style: {
                  width: '98%',
                  height: '100%'
                }
              })
            ])
          }
        })
      })
    }
  },
  mounted: function () {
    this.getNodeList()
  }
}
</script>

<style>
.ivu-poptip-body {
  text-align: left !important;
}
</style>
